import React, { useCallback, useEffect, useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import styles from '../../../styles/layout.module.css';
import { Breadcrumb, Button, Form, Input, Row, Space, Spin, Tag, Typography } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import tileStyles from 'src/styles/tile.module.css';

import { useForm } from 'antd/es/form/Form';
import { AppDispatch } from 'src/index';
import { createAccount, fetchAccounts } from 'src/features/accounts/accounts.state';
import { useAccountsState, useAccountsValues } from 'src/features/accounts/accounts.hooks';

const emptyUser = { username: '' };

const AccountsPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const accounts = useAccountsValues();
  const history = useHistory();

  const [form] = useForm();

  const [createMode, setCreateMode] = useState<boolean>(false);
  const [newEntity, setNewEntity] = useState<{ username: string }>(emptyUser);

  const handleCreateButtonClick = useCallback(() => {
    setCreateMode(true);
  }, []);

  const handleFormSubmit = useCallback(async () => {
    const response = await dispatch(createAccount({ data: newEntity }));

    if (createAccount.fulfilled.match(response)) {
      history.push(`/content/accounts/${response.payload.id}`);
    }
  }, [dispatch, history, newEntity]);

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/content/accounts'>
                <Space>
                  <UserOutlined />
                  Аккаунты
                </Space>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            Аккаунты
          </Typography.Title>
          <div>
            {createMode && (
              <Form
                form={form}
                validateTrigger='onBlur'
                layout='vertical'
                className={tileStyles.listTile}
                onFinish={handleFormSubmit}
              >
                <UserOutlined />
                <Form.Item name='username' rules={[{ required: true }]} noStyle>
                  <Input
                    type='text'
                    name='username'
                    placeholder='Введите имя пользователя'
                    style={{ width: '75%' }}
                    onChange={ev => setNewEntity(e => ({ ...e, username: ev.target.value }))}
                  />
                </Form.Item>
                <Button htmlType='button' type='default' onClick={() => setCreateMode(false)}>
                  Отменить
                </Button>
                <Button htmlType='submit' type='primary' disabled={newEntity.username === ''}>
                  Создать
                </Button>
              </Form>
            )}
            {accounts.map(c => (
              <div key={c.id} className={tileStyles.listTile}>
                <Link to={`/content/accounts/${c.id}`} className={tileStyles.tileName}>
                  <Space>
                    <UserOutlined />
                    <span>
                      {c.fullname} {c.email}
                    </span>
                  </Space>
                </Link>
                <Space align='center'>
                  {c.disabled && <Tag color='red'>Архивирован</Tag>}
                  {c.system && <Tag color='green'>Системный</Tag>}
                </Space>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.sidebar}>
          <Space>
            <Button type='primary' onClick={handleCreateButtonClick}>
              Создать новый аккаунт
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

const AccountsPageBlock: React.FC = () => {
  const dispatch = useDispatch();
  const accountsState = useAccountsState();

  useEffect(() => {
    dispatch(fetchAccounts({}));
  }, [dispatch]);

  if (accountsState.isPending) {
    return (
      <MainLayout>
        <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
          <Spin size={'large'} />
        </Row>
      </MainLayout>
    );
  }

  return <AccountsPage />;
};

export default AccountsPageBlock;
